<template>
    <div class="relative px-[20px] lg:px-[40px]">
        <step-options-initials-buttons
            v-if="visiblePlacementsPaintfill?.length > 0"
            :has-add-remove-button="hasAddRemoveButton"
            :has-local-error="hasLocalErrorState"
            :main-placement="visiblePlacementsPaintfill?.[0]"
            :option="paintfillOption"
            @unselect="handleSelectNothing"
            @select="handleSelectAndOpenPaintfillOptionsPanel"
            :index="0"
            :scroll-to-offset="0"
            :scroll-to-timeout="100"
            :has-error-state="hasLocalErrorState"
            :all-components="allComponents"
            :has-image="true"
            :open-when-selected="true"
            :should-scroll-to-clicked-button="false"
            :remove-selected-on-add-remove-click="true"
            :should-show-edit-button="true"
            @open="handleOpenPaintfillOptionsPanel"
            background-size="auto 100%"
        />
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import StepOptionsInitialsButtons from './buttons/StepOptionsInitialsButtons.vue';

    export default {
        mixins: [allStores],

        components: {
            StepOptionsInitialsButtons,
        },

        props: {
            visiblePlacementsPaintfill: {
                type: Array,
                required: true,
            },

            hasLocalErrorState: {
                type: Boolean,
                required: true,
            },

            hasPaintfillColorErrorState: {
                type: Boolean,
                default: false,
            },

            hasAddRemoveButton: {
                type: Boolean,
                default: false,
            },

            isActive: {
                type: Boolean,
                required: true,
            },

            isDirty: {
                type: Boolean,
                default: false,
            },

            scrollToOffset: {
                type: Number,
                default: 188,
            },
        },

        mounted() {
            if (this.isActive) {
                this.customizerStore.setActiveView('Sole');
            }
        },

        computed: {
            isMobile() {
                return this.appStore?.isMobile;
            },

            viewController() {
                return this.customizerStore.viewController;
            },

            allComponents() {
                if (!Array.isArray(this.visiblePlacementsPaintfill)) { return []; }
                const fullMainPlacement = this.visiblePlacementsPaintfill.find((x) => x.code === 'PutterFrontPaintfill');
                return fullMainPlacement?.components || [];
            },

            paintfillOption() {
                const stampPlacement = this.visiblePlacementsPaintfill.find((x) => x.code === 'PutterFrontPaintfill');

                const component = stampPlacement?.components?.find((x) => !x.placeholder);

                if (!component) {
                    return null;
                }

                return {
                    selected: this.isActive,
                    label: 'Paintfill',
                    value: component.code,
                    raw: {
                        ...component,
                        custom: {
                            ...(component.custom || {}),
                            ...{
                                'v-thumbnail-asset': 'PutterFace-PaintfillSelected',
                            },
                        },
                    },
                };
            },
        },

        methods: {
            handleSelectNothing() {
                this.$emit('unselect');
            },

            handleSelectAndOpenPaintfillOptionsPanel({ placement, option }) {
                this.selectActual({ placement, option });
                this.handleOpenPaintfillOptionsPanel();
            },

            handleOpenPaintfillOptionsPanel() {
                this.appStore.openNestedPanel('frontPaintfillOptions', {
                    visiblePlacementsPaintfill: this.visiblePlacementsPaintfill,
                    hasPaintfillColorErrorState: this.hasPaintfillColorErrorState,
                    isDirty: this.isDirty,
                });
            },

            selectActual({ placement, option }) {
                // Handle both cases: strings from button click, or objects from icon click
                const placementCode = typeof placement === 'string' ? placement : placement.code;
                const optionValue = typeof option === 'string' ? option : option.value;

                this.customizerStore.setSelection(placementCode, optionValue);

                // Emit the option value for the parent component
                const optionToEmit = typeof option === 'string' ? { value: optionValue } : option;
                this.$emit('select', optionToEmit);

                this.customizerStore.syncPaintfillFrom(placementCode);

                this.customizerStore.setActiveView('Sole');
            },
        },
    };
</script>
